<template>
  <div class="review-container mb-3">
    <h2>{{ header ? header : "Reviews" }}</h2>
    <hr />
    <div class="review-info">
      <div v-for="review of reviewInfo" :key="review.id" class="mb-3">
        <div class="reviewer-info">{{ getReviewerInfo(review) }}</div>
        <StarRating
          classList=""
          :disabled="true"
          :value="review.rating"
          :starSize="20"
        />
        <div class="review-text">
          {{ review.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "../common/complex-input-elements/StarRating.vue";

export default {
  name: "ReviewInfo",
  props: {
    header: String,
    reviewInfo: Array,
  },
  components: {
    StarRating,
  },
  methods: {
    getReviewerInfo(review) {
      const firstName = review.reviewer__first_name;
      let lastName = review.reviewer__last_name;
      if (lastName) {
        lastName = lastName[0] + ".";
      }
      return `${firstName} ${lastName}`.trim();
    },
  },
};
</script>

<style scoped>
.reviewer-info {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/users/ReviewInfo.vue